.newPin {
  display: flex;
  padding: var(--spacing-16);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-08);
  align-self: stretch;
  border-radius: var(--border-radius-02);
  background: var(--sparky-grey-100);

  .newPinHeader {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .newPinContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: var(--spacing-08);

    .textInput {
      width: 100%;
    }
  }

  .newPinFooter {
    display: flex;
    width: 100%;
    align-items: center;
    gap: var(--spacing-08);
    justify-content: space-between;

    .cancelButton,
    .discardButton {
      margin-left: auto;
    }
  }
}
